export default (text) => {
  return typeof text == 'string' ? text.toLowerCase() : text;
};
